<template>
<div class="btn-group" v-if="enabled && !!getText()">
  <button
    type="button"
    class="btn btn-sm btn-secondary"
    @click="navigate()"
  >
    {{ getText() }}
  </button>
</div>
</template>
<script>
export default {
  name: 'ContentNavigation',
  methods: {
    navigate () {
      this.$router.push(this.prevRoute)
    },
    getText () {
      if (this.isPreviousRouteShow) {
        return this.$t('buttons.backToShow')
      } else if (this.isPreviousRouteList) {
        return this.$t('buttons.backToList')
      } else return false
    }
  },
  computed: {
    isPreviousRouteShow () {
      return this.prevRoute.name.includes('Show')
    },
    isPreviousRouteList () {
      return this.prevRoute.name.includes('List')
    }
  },
  data () {
    return {
      enabled: false,
      prevRoute: null,
      routeHistory: []
    }
  },
  mounted () {
    this.$router.beforeEach((to, from, next) => {
      // this.routeHistory.push(from.name)
      this.prevRoute = from
      this.enabled = to.meta.defaultNav
      // console.log(this.getText())
      next()
    })
  }
}
</script>

<style scoped>

</style>
